import {
  Component, Output, EventEmitter, Input, OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss'],
})
export class TermsConditionComponent implements OnInit {
  termsCheck = false;

  @Output() termsClick = new EventEmitter();

  @Input() purpose: any;

  @Input() country!: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.country) {
      this.route.queryParams.subscribe((params) => {
        if (this.country === undefined && params['country']) {
          this.country = params['country'];
        }
        if (this.purpose === undefined && params['purpose']) {
          this.country = params['purpose'];
        }
      }); 
    }
  }

  toggleTermsCheck(value: boolean): void {
    this.termsCheck = value;
  }
}
